import script from "./tab-widget-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./tab-widget-ly.vue?vue&type=script&setup=true&lang=js"

import "./tab-widget-ly.vue?vue&type=style&index=0&id=59b529ea&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59b529ea"]])

export default __exports__